import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { sendErrorToSentryMiddleware } from './middlewares/sentry';
import { debugReducer } from './reducers/debug';
import { loginPageErrorsReducer } from './reducers/errorMessages/loginPageErrors';
import { securityPageErrorsReducer } from './reducers/errorMessages/securityPageErrors';
import { feedbackReducer } from './reducers/feedback';
import { profileReducer } from './reducers/profile';
import { shareReservationReducer } from './reducers/sharereservation';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

const store = configureStore({
    reducer: {
        profile: profileReducer,
        securityPageErrors: securityPageErrorsReducer,
        loginPageErrors: loginPageErrorsReducer,
        shareReservation: shareReservationReducer,
        debug: debugReducer,
        feedback: feedbackReducer,
    },
    preloadedState: {},
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat([sendErrorToSentryMiddleware]),
    enhancers: getDefaultEnhancers => {
        return getDefaultEnhancers().concat(sentryReduxEnhancer);
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export { store };
